import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'landing-background',
  styleUrl: 'landing-background.css',
})
export class LandingBackground {
  @Prop() white: boolean = false;
  @Prop() extendToBottom: boolean = false;

  render() {
    const classes = {
      relative: true,
      'shadow-infinite shadow-clrs-off-white': this.extendToBottom,
    };

    return (
      <div class={classes}>
        <div class="absolute w-full h-full -z-10 overflow-hidden">
          <slot name="background"></slot>
          {!this.white && <div class="h-full landing-background" />}
        </div>
        <div class="max-w-9xl mx-auto">
          <slot></slot>
        </div>
      </div>
    );
  }
}
